export default "__VITE_ASSET__C2IbjA1E__"